import { useState, useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import EFVideoModal from '@/components/UI/EFVideoModal';
import EFDelta2VideoPlayer from '@/components/UI/svg/Delta2/Icon/EFDelta2VideoPlayer';
import { youtubeMap } from '@/constants/delta2max';
import { STAGES } from '@/constants/delta2max';

export default function A({ stage }: any) {
    const { useLang, useRouter, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');
    const [enter, setEnter] = useState(false);
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const playerVideo = () => {
        setShowEFVideoModal(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA 2 Max | UX video',
            position: stage === STAGES.DETAIL ? 'Product Detail_1' : 'Product_1',
            __btn_id1: css.d2xTeaserA,
            __btn_id2: t('sec1_watch'),
        });
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setEnter(true);
        }, 500);

        // const scroll = () => {
        //     const header = document.querySelector('.ecoflow-header') as HTMLDivElement;
        //     const target = document.querySelector('.d2x-teaser-A .top-tip') as HTMLDivElement;
        //     const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        //     const topY = header?.offsetHeight >= scrollTop ? header?.offsetHeight - scrollTop : 0;
        //     target.style.transition = 'none';
        //     target.style.top = `${topY + 47}px`;
        // };
        // document.addEventListener('scroll', scroll);
        // return () => {
        //     document.removeEventListener('scroll', scroll);
        //     clearTimeout(timer);
        // };
    }, []);

    return (
        <div className={`d2x-teaser-A ${css.d2xTeaserA} GtmModuleData-btn-text`} data-section-id={css.d2xTeaserA} data-section-title={t('sec1_title')}>
            <div className={`top-tip ${enter ? 'enter' : ''} ${stage === STAGES.TEASER ? 'teaser' : 'detail'}`}>
                {stage === STAGES.TEASER ? t('sec1_top_note') : t('sec1_top_note2')}
            </div>
            <NextImage
                webpSrc={require(`@publicLocal/delta2max/teaser/h5/${locale === 'za' ? 'za/kv.jpg' : 'eu/kv.webp'}`)}
                src={require(`@publicLocal/delta2max/teaser/h5/${locale === 'za' ? 'za' : 'eu'}/kv.jpg`)}
                alt={t('sec1_title')}
                aria-label={t('sec1_title')}
            />
            <div className="reddot">
                <NextImage
                    webpSrc={require('@publicLocal/delta2max/reddot-black.webp')}
                    src={require('@publicLocal/delta2max/reddot-black.png')}
                    alt={t('sec1_title')}
                    aria-label={t('sec1_title')}
                />
            </div>
            <div className={`text-wrapper ${stage === STAGES.TEASER ? 'teaser' : 'detail'}`}>
                <p className="title">{t('sec1_title')}</p>
                <p className="desc date">{t('sec1_subtitle')}</p>
                {stage === STAGES.TEASER && <p className="date">{t('sec1_date')}</p>}
                <div className="video-btn GtmModuleData-btn-text" onClick={playerVideo}>
                    <p>{t('sec1_watch')}</p>
                    <div className="video-icon">
                        <EFDelta2VideoPlayer />
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={youtubeMap[locale] || youtubeMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
